import { useTranslation } from 'react-i18next'
import { z } from 'zod'

const currencyPattern = /^[\d,]+(\.\d{1,2})?$/

export interface PaymentFormData {
  totalTariff: string
  deposit: string
  carrierFee: string
  paymentMethod: string
  paymentTerms: string
  balanceMethod: string
  balanceTime: string
  balanceTermBegins: string
  paymentNote: string
}

export const EMPTY_PAYMENT_DEFAULTS: PaymentFormData = {
  totalTariff: '',
  deposit: '',
  carrierFee: '',
  paymentMethod: '',
  paymentTerms: '',
  balanceMethod: '',
  balanceTime: '',
  balanceTermBegins: '',
  paymentNote: '',
}

export function usePaymentSchema() {
  const { t } = useTranslation()

  const required = t('forms.validation.required')
  const invalid = t('forms.validation.invalidEmail')

  const requiredCurrency = (label: string) =>
    z
      .string()
      .min(1, `${label} ${required.toLowerCase()}`)
      .regex(currencyPattern, invalid)

  const optionalCurrency = z
    .string()
    .optional()
    .default('')
    .refine((v) => v === '' || currencyPattern.test(v), invalid)

  const optionalString = z.string().optional().default('')

  return z.object({
    totalTariff: requiredCurrency(t('orderCreate.payment.totalTariff')),
    deposit: requiredCurrency(t('orderCreate.payment.deposit')),
    carrierFee: optionalCurrency,
    paymentMethod: optionalString,
    paymentTerms: optionalString,
    balanceMethod: optionalString,
    balanceTime: optionalString,
    balanceTermBegins: optionalString,
    paymentNote: optionalString,
  })
}
